import "../styles/quickservices.scss";
import newconnection from "../assets/imgs/servicesicons/faucet.png";
import paywater from "../assets/imgs/servicesicons/payment-method.png";
import lodgecomplain from "../assets/imgs/servicesicons/rating.png";
import headoffice from "../assets/imgs/companypictures/headoffice.jpg";
import stakeholders from "../assets/imgs/companypictures/countyteam.jpg";
import mpesapaybill from "../assets/imgs/companypictures/mpesapaybill.png";
import item1 from "../assets/imgs/companypictures/jicavisit.jpg";
import item2 from "../assets/imgs/companypictures/cecwaterspeech.jpg";
import item3 from "../assets/imgs/companypictures/cispublicparticipants.jpg";
import item4 from "../assets/imgs/companypictures/githungurimca.jpg";
import item5 from "../assets/imgs/companypictures/githunguriocs.jpg";
import item6 from "../assets/imgs/companypictures/kiameruelevatedtank.jpg";
import item7 from "../assets/imgs/companypictures/kiameruchamber.jpg";
import item8 from "../assets/imgs/companypictures/kiamerucoagulationtanks.jpg";
import item9 from "../assets/imgs/companypictures/kiamerubackwasher.jpg";
import item10 from "../assets/imgs/companypictures/kiameruchemicalchambers.jpg";

// import managementwithdanida from "../assets/imgs/companypictures/managementwithdanida.jpg";
import corruption from "../assets/imgs/servicesicons/bribe.png";
import careers from "../assets/imgs/servicesicons/career.png";
import reports from "../assets/imgs/servicesicons/report.png";
import publications from "../assets/imgs/servicesicons/seo-report.png";
import newsevents from "../assets/imgs/servicesicons/calendar.png"
import contacts from "../assets/imgs/servicesicons/complain.png";
import Carousel from "./carousel";

import { faEnvelope, faX, faIns, faLocation, faLocationPin, faPhone, faUserCheck, faWater, faPlug, faTools, faHeadset, faTachometer, faTachometerAlt, faFaucet, faFaucetDrip, faSync } from '@fortawesome/free-solid-svg-icons';
import SingleServiceLink from "./singleservicelink";

export default function QuickServices (props) {

    return (
        <div className="quickservices">
            {/* <div className="carousel">
                <img src={team} alt="" />
            </div> */}
            {/* <Carousel images = {[headoffice, mpesapaybill, stakeholders, dsifvisit, govnmd, management2, kiamerufloc2ed, borehole2, team, listening, customercakecut]}/> */}
            <Carousel images = {[headoffice, mpesapaybill, stakeholders, item1, item2, item3, item4, item5, item6, item7, item8, item9,item10]}/>
            <div className="quickbuttons">
                <SingleServiceLink icon= {newconnection} text="New Water Connection" page="services/#newconnection" />
                <SingleServiceLink icon= {paywater} text="Pay for services" page="services/#paybill" />
                <SingleServiceLink icon= {lodgecomplain} text="Lodge a complain" page="contactus" />

                <SingleServiceLink icon= {corruption} text="Report corruption" page="reportcoruption" />
                {/* <SingleServiceLink icon= {faFaucetDrip} text="Tenders" /> */}
                <SingleServiceLink icon= {careers} text="Careers" page="careers"/>

                <SingleServiceLink icon= {reports} text="Reports" page="reports" />
                <SingleServiceLink icon= {publications} text="Publications & Downloads" page="publications"/>
                <SingleServiceLink icon= {newsevents} text="News & Events" page="newsandevents"/>
                
                <SingleServiceLink icon= {contacts} text="Contact Us" page="contactus" />
            </div>
        </div>         
    );
}